export class ResourceBackupSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gwsFilterJson",
            "baseName": "gwsFilterJson",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceBackupSettings.attributeTypeMap;
    }
    constructor() {
    }
}
